import { useEffect, useState } from "react";
import { GET_NOC_DASHBOARD_REPORT_URL } from "../../../../api/api_routing_urls";
import { axiosPrivate } from "../../../../api/axios";
import NocReportSummaryCard from "./NocReportSummaryCard";
import Dashboard from "../../../../common/Dashboard";
import useAuth from "../../../../authentication/hooks/useAuth";
import NocReportPurposeGraph from "./NocReportPurposeGraph";
import NocReportCountVerifiedAndUnVerified from "./NocReportCountVerifiedAndUnVerified";
import NocReportPaymentMode from "./NocReportPaymentMode";
import { LuFilter, LuX } from "react-icons/lu";

const NocReportHome = () => {
  const { auth } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [filterText, setFilterText] = useState("");

  const [fullData, setFullData] = useState([]);

  console.log({ fullData });

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const payload = {
          filter_text: filterText || null,
        };
        const res = await axiosPrivate.post(
          GET_NOC_DASHBOARD_REPORT_URL,
          payload,
        );

        if (res?.data?.status == 200) {
          setFullData(res?.data?.response || []);
        }
      } catch (error) {
        console.error("error", error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 900);
      }
    })();
  }, [filterText]);
  return (
    <div>
      <Dashboard sidebarType={auth?.rolename}>
        <div>
          <div className="flex flex-col gap-4">
            {filterText && (
              <div className="flex items-center justify-between rounded-lg border border-slate-200 bg-white px-3 py-2 dark:border-slate-800 dark:bg-slate-900">
                <div className="flex items-center gap-2">
                  <LuFilter className="h-4 w-4 text-primary" />

                  <span className="text-xs text-slate-500">Filter:</span>

                  <span className="text-sm font-semibold capitalize text-slate-800 dark:text-white">
                    {filterText.replaceAll("_", " ")}
                  </span>
                </div>

                <button
                  onClick={() => setFilterText(null)}
                  className="flex items-center gap-1 text-xs font-medium text-slate-500 transition hover:text-red-600"
                >
                  <LuX className="h-3.5 w-3.5" />
                  Clear
                </button>
              </div>
            )}

            <NocReportSummaryCard
              setFilterText={setFilterText}
              data={fullData?.convenience_fee_summary}
              isLoading={isLoading}
              filterText={filterText}
            />
            <div className="flex items-center justify-center gap-5">
              <div className="w-[30%]">
                <NocReportCountVerifiedAndUnVerified
                  data={fullData?.verification_summary}
                />
              </div>
              <div className="w-[68%]">
                <NocReportPurposeGraph data={fullData?.purpose_summary} />
              </div>
            </div>

            <NocReportPaymentMode data={fullData?.payment_mode_summary} />
          </div>
        </div>
      </Dashboard>
    </div>
  );
};

export default NocReportHome;
